<template>
  <button
    v-if="visible"
    type="button"
    class="floating-robot-link"
    title="AI-LEE"
    aria-label="打开 AI-LEE"
    @click="$emit('click')"
  >
    <img src="@/assets/icon-ai.png" />
    <div class="floating-robot-link-text">
      <div>AI-LEE</div>
      <div>问答</div>
    </div>
  </button>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "FloatingRobotLink",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped lang="scss">
.floating-robot-link {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  color: #ffffff;
  background: linear-gradient(135deg, #2f7cff 0%, #13c2c2 100%);
  box-shadow: 0 12px 30px rgba(47, 124, 255, 0.32);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 16px 36px rgba(47, 124, 255, 0.4);
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 3px;
  }

  img {
    width: 30px;
    height: 30px;
    margin-top: -6px;
  }

  .floating-robot-link-text {
    font-size: 11px;
    line-height: 1;
    letter-spacing: 0.5px;
    >div:nth-child(1) {
      font-weight: 600;
    }
  }

  .eye {
    fill: #2f7cff;
    stroke: none;
  }
}

@media (max-width: 768px) {
  .floating-robot-link {
    right: 16px;
    bottom: 16px;
    width: 56px;
    height: 56px;

    img {
      width: 26px;
      height: 26px;
    }

    .floating-robot-link-text {
      font-size: 10px;
    }
  }
}
</style>


